module.exports = __webpack_public_path__ + "static/media/pause-white.e9f3fd53.svg";